import { __assign, __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
import InternalIcon from '../icon/internal';
import InternalSpinner from '../spinner/internal';
var typeToIcon = {
    error: React.createElement(InternalIcon, { name: "status-negative" }),
    warning: React.createElement(InternalIcon, { name: "status-warning" }),
    success: React.createElement(InternalIcon, { name: "status-positive" }),
    info: React.createElement(InternalIcon, { name: "status-info" }),
    stopped: React.createElement(InternalIcon, { name: "status-stopped" }),
    pending: React.createElement(InternalIcon, { name: "status-pending" }),
    'in-progress': React.createElement(InternalIcon, { name: "status-in-progress" }),
    loading: React.createElement(InternalSpinner, null)
};
export default function StatusIndicator(_a) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? 'success' : _c, children = _a.children, iconAriaLabel = _a.iconAriaLabel, colorOverride = _a.colorOverride, __uxdgInverted = _a.__uxdgInverted, _d = _a.__animate, __animate = _d === void 0 ? false : _d, __internalRootRef = _a.__internalRootRef, rest = __rest(_a, ["type", "children", "iconAriaLabel", "colorOverride", "__uxdgInverted", "__animate", "__internalRootRef"]);
    var baseProps = getBaseProps(rest);
    return (React.createElement("span", __assign({}, baseProps, { className: clsx(styles.root, styles["status-" + type], (_b = {},
            _b[styles["color-override-" + colorOverride]] = colorOverride,
            _b[styles['uxdg-inverted']] = __uxdgInverted,
            _b), baseProps.className), ref: __internalRootRef }),
        React.createElement("span", { className: clsx(styles.container, __animate && styles['container-fade-in']) },
            React.createElement("span", { className: clsx(styles.icon, __animate && styles['icon-shake']), "aria-label": iconAriaLabel, role: iconAriaLabel ? 'img' : undefined }, typeToIcon[type]),
            children)));
}
//# sourceMappingURL=internal.js.map